import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function ForgotPassword() {
  const [email,   setEmail]   = useState('');
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Klaida. Bandykite vėliau.');
    } finally { setLoading(false); }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">🔐</div>
        <div className="login-title">Slaptažodžio atstatymas</div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
            <p style={{ color: 'var(--text-muted)', marginBottom: 8 }}>
              Jei <strong style={{ color: 'var(--text)' }}>{email}</strong> yra registruotas,
              netrukus gausite atstatymo nuorodą.
            </p>
            <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 24 }}>
              Patikrinkite el. pašto dėžutę ir Spam aplanką.
            </p>
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-flex', justifyContent: 'center' }}>
              ← Grįžti į prisijungimą
            </Link>
          </div>
        ) : (
          <>
            <p style={{ color: 'var(--text-muted)', textAlign: 'center', marginBottom: 24, fontSize: 14 }}>
              Įveskite savo el. pašto adresą – atsiųsime slaptažodžio atstatymo nuorodą.
            </p>

            {error && <div className="alert alert-error" style={{ marginBottom: 16 }}>{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">El. pašto adresas</label>
                <input className="form-input" type="email" value={email} autoFocus
                  onChange={e => setEmail(e.target.value)} required placeholder="jusu@pastas.lt" />
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading}
                style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
                {loading ? <span className="loading-spinner" /> : '📧 Siųsti atstatymo nuorodą'}
              </button>
            </form>

            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link to="/login" style={{ color: 'var(--text-muted)', fontSize: 13, textDecoration: 'none' }}>
                ← Grįžti į prisijungimą
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
